module.exports = __webpack_public_path__ + "static/media/avatar-1.e8d09e18.png";